<template>
  <div>
    <div v-if="config.subject === 'words' || config.subject === 'line'">
      <el-form-item label="题干">
        <div class="exr-form-subject">
          <el-input v-model="form.subject"></el-input>
          <PinyinInput v-model="form.subjectPinyin" v-if="config.subjectPinyin" :text="form.subject" :uppercase="true"></PinyinInput>
        </div>
      </el-form-item>
      <PinyinPreview v-if="config.subjectPinyin" :text="form.subject" :pinyin="form.subjectPinyin" popover offsets></PinyinPreview>
    </div>
    <div v-else-if="config.subject === 'text' || config.subject === 'dialog'">
      <el-form-item label="题干" @change.native.capture="handleDialogText(form, 'subject', 'subjectPinyin')">
        <PinyinGridInput v-if="config.subjectPinyin" :text.sync="form.subject" :pinyin.sync="form.subjectPinyin"></PinyinGridInput>
        <el-input v-else type="textarea" v-model="form.subject" resize="none" :autosize="{minRows:2}"></el-input>
      </el-form-item>
    </div>
    <div v-if="config.question">
      <el-form-item label="提问">
        <div class="exr-flex-row">
          <el-input v-model="form.question"></el-input>
          <PinyinInput v-model="form.questionPinyin" v-if="config.questionPinyin" :text="form.question"></PinyinInput>
        </div>
      </el-form-item>
    </div>
    <PinyinPreview v-if="config.questionPinyin" :text="form.question" :pinyin="form.questionPinyin" popover offsets></PinyinPreview>
    <el-form-item label="图片" v-if="config.image">
      <ImageInput v-model="form.image" :desc.sync="form.imageDesc"></ImageInput>
    </el-form-item>
    <el-form-item label="音频" v-if="config.audio">
      <FileInput v-model="form.audio" accept="audio/*"></FileInput>
    </el-form-item>
    <el-form-item label="音频原文" v-if="config.audioText">
      <PinyinGridInput :text.sync="form.audioText" :pinyin.sync="form.audioPinyin"></PinyinGridInput>
    </el-form-item>
    <div v-if="config.items === 'words' || config.items === 'line'">
      <el-form-item class="exr-items"  label="选项">
        <div class="exr-item-wrap" v-for="(value, key) in form.items" :key="key">
          <div class="exr-item">
            <el-input v-model="value.text" @paste.native.capture.prevent="handlePasteItems($event, key)"></el-input>
            <PinyinInput v-model="value.pinyin" v-if="config.itemsPinyin" :text="value.text" :uppercase="false"></PinyinInput>
            <FileInput v-model="value.audio" v-if="config.itemsAudio" accept="audio/*" tiny></FileInput>
            <el-button type="danger" tabindex="-1" icon="el-icon-delete" @click="removeItem(key)"></el-button>
            <el-button icon="el-icon-plus" tabindex="-1" v-if="showAddItem" @click="addItem(key)"></el-button>
          </div>
          <PinyinPreview v-if="config.itemsPinyin" :text="value.text" :pinyin="value.pinyin" popover></PinyinPreview>
        </div>
      </el-form-item>
      <el-form-item label="正确答案" :class="'exr-answer-' + config.items">
        <el-radio v-for="(value, key) in form.items" :key="key" :label="key" v-model="form.answer">{{key + 1}}.{{value.text}}</el-radio>
      </el-form-item>
    </div>
    <div v-else-if="config.items === 'image'">
      <el-form-item class="exr-items" label="图片选项">
        <div class="exr-item-wrap" v-for="(value, key) in form.items" :key="key">
          <div class="exr-item">
            <ImageInput v-model="value.image" :desc.sync="value.imageDesc"></ImageInput>
            <FileInput v-model="value.audio" v-if="config.itemsAudio" accept="audio/*" tiny></FileInput>
            <el-button type="danger" tabindex="-1" icon="el-icon-delete" @click="removeItem(key)"></el-button>
            <el-button icon="el-icon-plus" tabindex="-1" v-if="showAddItem" @click="addItem(key)"></el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="正确答案">
        <el-radio v-for="(value, key) in form.items" :key="key" :label="key" v-model="form.answer">{{key + 1}}</el-radio>
      </el-form-item>
    </div>
    <el-form-item label="答案音频" v-if="config.answerAudio">
      <FileInput v-model="form.answerAudio" accept="audio/*"></FileInput>
    </el-form-item>
    <ShowAnswer v-model="form" :config="config"></ShowAnswer>
  </div>
</template>

<script>
  import basexzt from './base-xzt.js'
  import dialog from '@/components/mixins/dialog.js'
  import PinyinPreview from "@/components/PinyinPreview"
  import PinyinInput from "@/components/PinyinInput"
  import PinyinGridInput from "@/components/PinyinGridInput"
  import FileInput from "@/components/FileInput"
  import ImageInput from "@/components/ImageInput"
  import ShowAnswer from "./ShowAnswer"

  export default {
    name: 'XztForm',
    components: {
      PinyinPreview,
      PinyinInput,
      PinyinGridInput,
      FileInput,
      ImageInput,
      ShowAnswer
    },
    mixins: [basexzt,dialog],
  }
</script>

<style lang="scss" scoped>
  .exr-form-subject{
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    > div{
      flex: 1;
      margin-left: 8px;
      min-width: 300px;
    }
  }
  .exr-flex-row{
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    > div{
      flex: 1;
      margin-left: 8px;
    }
  }
  .exr-items{
    margin-bottom: 20px;
    .exr-item{
      display: flex;
      > .el-radio{
        margin-right: 0;
      }
      > .el-input, > .file-input{
        flex: 1;
        + .el-input, + .file-input{
          margin-left: 8px;
        }
      }
      > .el-button{
        width: 40px;
        height: 40px;
        padding: 0;
        line-height: 40px;
        text-align: center;
        margin-left: 8px;
      }
    }
    .exr-item-wrap + .exr-item-wrap{
      margin-top: 12px;
    }
    .exr-item-wrap > .popover-preview.offset-form{
      left: 69px;
    }
  }
</style>
